import { Box } from "@mui/material";
import React, { ReactNode } from "react";

type SkeletonCollectionProps = {
  isLoading?: boolean;
  skeleton?: ReactNode;
};
export const SkeletonCollection: React.FC<SkeletonCollectionProps> = ({
  isLoading = false,
  skeleton,
  children,
}) => {
  if (isLoading) {
    return <Box>{skeleton}</Box>;
  }

  return <Box>{children}</Box>;
};
